import { asString, isRecord } from '../cellValues';
export const asLinkEntries = (value)=>{
    if (!Array.isArray(value)) return [];
    return value.flatMap((entry)=>{
        if (!isRecord(entry)) return [];
        const label = asString(entry.label);
        const to = asString(entry.to);
        return label != null && to != null ? [
            {
                label,
                to
            }
        ] : [];
    });
};
